import { BTButtonDeprecated } from "commonComponents/btWrappers/BTButtonDeprecated/BTButtonDeprecated";
import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTExternalLink } from "commonComponents/btWrappers/BTExternalLink/BTExternalLink";
import { BTIconExternalLink, BTIconPlus } from "commonComponents/btWrappers/BTIcon";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import { BTTitle } from "commonComponents/btWrappers/BTTitle/BTTitle";
import HomeDepotProXtraLogo from "commonComponents/entity/vendor/HomeDepotLogo/HomeDepotProXtraLogo";
import { BTLogoDeprecated } from "commonComponents/utilities/BTLogo/BTLogoDeprecated";

import "./HomeDepotUnconnectedDisplay.less";

interface IHomeDepotUnconnectedDisplayProps {
    title: React.ReactNode;
    details: React.ReactNode;
    onClick: () => void;
    showLearnMoreLink?: boolean;
    showGettingStartedLink?: boolean;
    showConnectButton?: boolean;
    onLearnMore?: () => void;
}

export function HomeDepotBTLogo() {
    return (
        <div className="IconContainer">
            <BTLogoDeprecated layout="minimal" color="dark-blue-blue" size="sm" />
            <BTIconPlus className="margin-horizontal-md" size="extraLarge" />
            <HomeDepotProXtraLogo height={47} />
        </div>
    );
}

export const HomeDepotUnconnectedDisplay: React.FunctionComponent<
    IHomeDepotUnconnectedDisplayProps
> = ({
    title,
    details,
    onClick,
    showLearnMoreLink,
    showGettingStartedLink,
    showConnectButton,
    onLearnMore,
}) => (
    <div className="HomeDepotUnconnectedDisplay text-center">
        <div className="margin-vertical-lg">
            <HomeDepotBTLogo />
        </div>
        <BTTitle level={1}>{title}</BTTitle>
        <BTRow className="margin-bottom-md">
            <BTCol className="text-center" md={{ span: 12, offset: 6 }}>
                {details}
            </BTCol>
        </BTRow>
        {showConnectButton && (
            <BTButtonDeprecated type="primary" data-testid="connect" onClick={onClick}>
                Connect to The Home Depot Pro Xtra
            </BTButtonDeprecated>
        )}
        {showLearnMoreLink && (
            <div className="margin-top-sm">
                <BTButtonDeprecated type="link" data-testid="learn-more" onClick={onLearnMore}>
                    Chat with us to learn more
                </BTButtonDeprecated>
            </div>
        )}
        {showGettingStartedLink && (
            <div className="margin-vertical-lg">
                Need more help getting started?&nbsp;
                <BTExternalLink href="https://helpcenter.buildertrend.net/en/collections/2860591-the-home-depot-integration">
                    Help Center <BTIconExternalLink />
                </BTExternalLink>
            </div>
        )}
    </div>
);
